var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-filter",class:{'loader-filter--is-loading': _vm.isLoading, 'loader-filter--without-opacity': _vm.withoutOpacity, 'loader-filter--without-background': _vm.withoutBackground}},[_c('div',{staticClass:"loader",style:({border: _vm.borderSize + 'px solid #f3f3f3', borderTop: _vm.borderSize + 'px solid #FF2F00'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }